import classnames from 'classnames';
import { useResponsiveWidth, useUser } from 'libs';

interface TrainingProps {
  brokerageName?: string;
  onSignupClick?: (brokerageName?: string) => void;
}

const Training = ({ brokerageName, onSignupClick }: TrainingProps) => {
  const { features } = useUser();
  const { isMinSm } = useResponsiveWidth();

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex gap-2">
          <div className={classnames({ 'flex-basis-50': isMinSm, 'flex-basis-100': !isMinSm })}>
            <h4 className="fw-bold mb-2">Need help with Lender Spotlight?</h4>
            <div className="mb-8 mt-3">
              {`Learn how to optimize Lender Spotlight ${features.has_brokerage ? 'for your team' : ''} in this FREE training session.`}
            </div>
            <a
              className="btn btn-primary-dark btn-reset fw-bold"
              href="https://calendly.com/charles-chometsky-lendesk/guided-exploration-of-lender-spotlight"
              onClick={() => onSignupClick?.(brokerageName)}
              rel="noopener noreferrer"
              target="_blank"
            >
              Sign up for training
            </a>
          </div>
          <div
            className={classnames('d-flex justify-content-end', {
              'flex-basis-50': isMinSm,
              'd-none': !isMinSm,
            })}
          >
            <img alt="training session" src="/images/upgrade-training.png" style={{ maxWidth: 275 }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Training;
